'use strict';
(function () {
  angular
    .module('specsguardApp')
    .service('sgElementActivityService', sgElementActivityService);

    sgElementActivityService.$inject = ['$log', '$rootScope', '$stateParams', 'Project', 'ProjectDataservice'];

  function sgElementActivityService ($log, $rootScope, $stateParams, ProjectAPI, ProjectDataservice) {

    /**
     * Get Element logs from API.
     *
     * @param {ProjectElement} element Element object.
     * @returns {Promise<ProjectElementLog[]} Element logs.
     */
    this.getLogs = (element: ProjectElement): Promise<ProjectElementLog[]> => {
      return new Promise((resolve, reject) => {

        $rootScope.$emit('transitionnotifier:start');

        const request = {
          id: $stateParams.project_id,
          paramId: element.moduleId,
          secondParamId: element.submoduleId,
          thirdParamId: element._id,
        };

        ProjectAPI.getLogs(request).$promise.then((response: any) => {
          $rootScope.$emit('transitionnotifier:end');
          resolve(response.logs);
        }, (error: any) => {
          $log.error(error);
          $rootScope.$emit('transitionnotifier:end');
          reject();
        });

      });
    }

  }
})();
